import { useEffect } from 'react';
import { toAbsoluteUrl } from '../_metronic/helpers';

interface Props {
    title: string;
    icon?: string;
}

const useDynamicTab: any = ({ title, icon }: Props) => {
    useEffect(() => {
        document.title = title;

        if (icon) {
            document.querySelector("link[rel~='icon']")?.setAttribute('href', icon);
        } else {
            document.querySelector("link[rel~='icon']")?.setAttribute('href', toAbsoluteUrl('/media/logos/logo-wooblazz.png'));
        }
    }, [title, icon]);
};

export default useDynamicTab;